import { useCallback } from 'react';

import { Box } from '@hivebrite/design-system/Box';

import JobsV2App from 'hb-react/frontoffice/apps/JobsV2';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { WithAppPageConfig } from 'hb-react/frontoffice/utils/WithAppPageConfig';

const JobsAppWrapper = ({ topic }) => {
  const { currentUser } = useDefaultAppContexts();

  const jobsAppFO = useCallback(
    ({ appPageConfig }) => (
      <JobsV2App
        topic={topic}
        configPage={appPageConfig}
        configUrls={() => ({
          pathRoot: `/topics/${topic.id}/opportunities`,
          editItem: ({ opportunityId }) =>
            Routes.topic_edit_opportunity_path(topic.id, opportunityId),
          deleteItem: ({ opportunityId }) =>
            Routes.topics_topic_business_opportunities_requests_path(
              topic.id,
              opportunityId,
            ),
          fetchItem: ({ opportunityId }) =>
            Routes.topics_topic_business_opportunities_request_path(
              topic.id,
              opportunityId,
            ),
          fetchItems: Routes.topics_topic_business_opportunities_requests_path(
            topic.id,
          ),
          fetchTagOptions:
            Routes.tag_options_topics_topic_business_opportunities_requests_path(
              topic.id,
            ),
        })}
      />
    ),
    [topic],
  );

  if (currentUser) {
    return (
      <WithAppPageConfig identifier="business_opportunities">
        {jobsAppFO}
      </WithAppPageConfig>
    );
  }

  return (
    <JobsV2App
      topic={topic}
      configUrls={({ currentUser }) => ({
        pathRoot: `/topics/${topic.id}/opportunities`,
        editItem: () =>
          Routes.topic_business_opportunities_requests_path(topic.id),
        deleteItem: () =>
          Routes.topic_business_opportunities_requests_path(topic.id),
        fetchItem: ({ opportunityId }) =>
          Routes.topic_business_opportunities_request_path(
            topic.id,
            opportunityId,
          ),
        fetchItems: Routes.topic_business_opportunities_requests_path(topic.id),
        fetchTagOptions: currentUser
          ? Routes.tag_options_topics_topic_business_opportunities_requests_path(
              topic.id,
            )
          : Routes.tag_options_topic_business_opportunities_requests_path(
              topic.id,
            ),
      })}
    />
  );
};

const TopicJobsContainer = (props) => (
  <Box mt={6} flexDirection="column">
    <JobsAppWrapper {...props} />
  </Box>
);

export default TopicJobsContainer;
